import type { IFigure } from "./adjust-figures-preferences-modal.types";

/**
 * Compares two figure selections by id and order. Used to detect whether the
 * user actually changed the selection before triggering an apply/refetch.
 */
export const areFigureSelectionsEqual = ({ current, previous }: { current: IFigure[]; previous: IFigure[] }) => {
    if (current.length !== previous.length) {
        return false;
    }

    return current.every((figure, index) => figure.id === previous[index]?.id);
};

/**
 * Returns the figure's full label with soft hyphenation removed, so a wrapped
 * label like "Emissions-\ndatum" is displayed as "Emissionsdatum".
 */
export const getDisplayLabel = (figure: IFigure): string => figure.fullLabel.replaceAll("-\n", "");
